import axios from 'axios';
import { SERVER_URL } from '../constants';
import { ApolloClient, InMemoryCache } from '@apollo/client';

export async function handleResponse(response) {
  const { status, data } = response;

  if (status === 400) {
    const error = await response.text();
    throw new Error(error.message[0]);
  }

  return data;
}

export function handleError(error) {
  // eslint-disable-next-line no-console
  console.error('API call failed. ' + error);
  throw error;
}

export const defaultHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: 'Bearer ' + localStorage.getItem('jwt'),
});
export const authHeader = () => ({
  Authorization: 'Bearer ' + localStorage.getItem('jwt'),
});

export const handleErrorMessage = e => new Error(e.message);

export const authBearer = () => {
  return 'Bearer ' + localStorage.getItem('jwt');
};

export const getAxios = () => {
  axios.defaults.baseURL = SERVER_URL;

  if (localStorage.getItem('jwt')) {
    axios.defaults.headers.common['Authorization'] = authBearer();
  }

  axios.interceptors.response.use(
    res => res,
    err => {
      if ([401, 403].includes(err?.response?.status)) {
        localStorage.clear();
        window.location = '/login';
      }
      throw new Error();
    }
  );
  return axios;
};

export const getGraphql = () => {
  const defaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  };
  return new ApolloClient({
    uri: SERVER_URL + '/graphql',
    cache: new InMemoryCache(),
    defaultOptions,
  });
};
